export enum MapTypes {
    mapColor = 'mapColor',
    mapColorGray = 'mapColorGray',
    mapSatellite = 'mapSatellite',
    mapSatelliteWithNames = 'mapSatelliteWithNames'
}